import ImageMessage from './ImageMessage';

export default ImageMessage;
